import BaseService, { CloudBaseIdentityService } from './BaseService'
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'

const IdentityApiService = {
    fetchData<Response = unknown, Request = Record<string, unknown>>(
        param: AxiosRequestConfig<Request>,
    ) {
        return new Promise<AxiosResponse<Response>>((resolve, reject) => {
            CloudBaseIdentityService(param)
                .then((response: AxiosResponse<Response>) => {
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    reject(errors)
                })
        })
    },
}

export default IdentityApiService
